import { toast } from 'react-toastify';

const TonalidadeModal = ({
    show,
    modalTonalidadeTipo,
    campoFotos,
    setCampoFotos,
    indiceSelecionado,
    setIndiceSelecionado,
    statusSelecionado,
    setStatusSelecionado,
    indicesModalTonalidade,
    mainLancamentoRowData,
    aprovadorTecidoTinto,
    aprovadorTecidoEstampado,
    setLoadingModal,
    styles,
    // suporte para acumular imagens parciais no componente pai (Solução 1)
    tonalidadeImagensAcumuladas,
    onPartialTonalidadeSave,
    clearTonalidadeImagens,
    // Props adicionais para a função finalizarTonalidadeModal
    setShowTonalidadeModal,
    defeitos,
    registrarAnalisePeca,
    registrarAnalisePecaComDefeitos,
    setAnalisesPeca,
    setDefeitosGrid,
    setMainLancamentoRowData,
    setDefeitos,
    carregarStatus,
    onTonalidadeFinish
}) => {
    if (!show) return null;

    // Verificar se os dados necessários estão disponíveis
    if (!mainLancamentoRowData || !modalTonalidadeTipo) {
        return null;
    }

    // Função para finalizar o modal de tonalidade e inserir no grid modal principal
    const finalizarTonalidadeModal = async () => {
        setShowTonalidadeModal(false);
        // Função utilitária para conversão segura
        const parseFloatOrNull = v => {
            if (v === undefined || v === null || v === '' || v === 'NULL') return null;
            const n = parseFloat(String(v).replace(',', '.'));
            return isNaN(n) ? null : n;
        };
        // Monta o objeto tonalidade apenas com os campos do modal atual
        let tonalidade = {};
        if (modalTonalidadeTipo === 'primeira') {
            if (indiceSelecionado.foto1) {
                tonalidade.indiceInicioMaisMeioDoRolo = parseFloatOrNull(indiceSelecionado.foto1);
                tonalidade.statusInicioMaisMeioDoRolo = statusSelecionado.foto1;
            }
            if (indiceSelecionado.foto2) {
                tonalidade.indiceInicioMaisFinalDoRolo = parseFloatOrNull(indiceSelecionado.foto2);
                tonalidade.statusInicioMaisFinalDoRolo = statusSelecionado.foto2;
            }
            if (indiceSelecionado.foto3) {
                tonalidade.indiceOurelaEsqCentroDireita = parseFloatOrNull(indiceSelecionado.foto3);
                tonalidade.statusOurelaEsqCentroDireita = statusSelecionado.foto3;
            }
        } else if (modalTonalidadeTipo === 'segunda') {
            if (indiceSelecionado.foto4) {
                tonalidade.indicePrimeiraMaisSegundaPecaDoLote = parseFloatOrNull(indiceSelecionado.foto4);
                tonalidade.statusPrimeiraMaisSegundaPecaDoLote = statusSelecionado.foto4;
            }
        } else if (modalTonalidadeTipo === 'última') {
            if (indiceSelecionado.foto5) {
                tonalidade.indiceUmaPecaDeCadaLote = parseFloatOrNull(indiceSelecionado.foto5);
                tonalidade.statusUmaPecaDeCadaLote = statusSelecionado.foto5;
            }
        }

        const imagensTonalidade = [];
        if (modalTonalidadeTipo === 'primeira') {
            if (campoFotos?.imagemInicioMaisMeioDoRolo && campoFotos.imagemInicioMaisMeioDoRolo.file) {
                imagensTonalidade.push({ file: campoFotos.imagemInicioMaisMeioDoRolo.file, name: 'imagemInicioMaisMeioDoRolo.jpg' });
            }
            if (campoFotos?.imagemInicioMaisFinalDoRolo && campoFotos.imagemInicioMaisFinalDoRolo.file) {
                imagensTonalidade.push({ file: campoFotos.imagemInicioMaisFinalDoRolo.file, name: 'imagemInicioMaisFinalDoRolo.jpg' });
            }
            if (campoFotos?.imagemOurelaEsqCentroDireita && campoFotos.imagemOurelaEsqCentroDireita.file) {
                imagensTonalidade.push({ file: campoFotos.imagemOurelaEsqCentroDireita.file, name: 'imagemOurelaEsqCentroDireita.jpg' });
            }
        }
        if (modalTonalidadeTipo === 'segunda') {
            if (campoFotos?.imagemPrimeiraMaisSegundaPecaDoLote && campoFotos.imagemPrimeiraMaisSegundaPecaDoLote.file) {
                imagensTonalidade.push({ file: campoFotos.imagemPrimeiraMaisSegundaPecaDoLote.file, name: 'imagemPrimeiraMaisSegundaPecaDoLote.jpg' });
            }
        }
        if (modalTonalidadeTipo === 'última') {
            if (campoFotos?.imagemUmaPecaDeCadaLote && campoFotos.imagemUmaPecaDeCadaLote.file) {
                imagensTonalidade.push({ file: campoFotos.imagemUmaPecaDeCadaLote.file, name: 'imagemUmaPecaDeCadaLote.jpg' });
            }
        }

        if (window._finalizarTonalidadeModalHandler) {
            window._finalizarTonalidadeModalHandler();
            // Corrige: limpa o handler global para evitar múltiplas chamadas
            window._finalizarTonalidadeModalHandler = null;
            // Se o modal atual NÃO for o último, salvar parcial no parent e retornar
            if (modalTonalidadeTipo !== 'última') {
                try {
                    if (typeof onPartialTonalidadeSave === 'function') {
                        onPartialTonalidadeSave({ tonalidade, imagens: imagensTonalidade.map(i => ({ file: i.file, name: i.name })) });
                    }
                } catch (e) {
                    console.error('Erro salvando parcial tonalidade no parent', e);
                } finally {
                    if (setLoadingModal) setLoadingModal(false);
                    // não limpar campoFotos global aqui, deixamos para o envio final
                }
                // Não prossegue com envio final aqui
                return;
            }
            // Se o modal atual for o último, executa a inserção
            if (modalTonalidadeTipo === 'última') {
                const defeitosValidos = Array.isArray(defeitos) && defeitos.filter(d => d.defeito || d.localizacao || d.tamanho || d.pontuacao);
                if (!defeitosValidos || defeitosValidos.length === 0) {
                    if (typeof registrarAnalisePeca === 'function' && mainLancamentoRowData) {
                        const parseFloatOrNull = v => {
                            if (v === undefined || v === null || v === '' || v === 'NULL') return null;
                            const n = parseFloat(String(v).replace(',', '.'));
                            return isNaN(n) ? null : n;
                        };
                        const analisePeca = {
                            idMpTriangulacaoRev: mainLancamentoRowData.idMpTriangulacaoRev,
                            pedido: mainLancamentoRowData.pedido,
                            lote: parseFloatOrNull(mainLancamentoRowData.lote),
                            peca: parseFloatOrNull(mainLancamentoRowData.peca),
                            larguraFornecedor: parseFloatOrNull(mainLancamentoRowData.larguraFornecedor),
                            larguraInicio: parseFloatOrNull(mainLancamentoRowData.larguraInicio),
                            larguraMeio: parseFloatOrNull(mainLancamentoRowData.larguraMeio),
                            larguraFim: parseFloatOrNull(mainLancamentoRowData.larguraFim),
                            ourela: parseFloatOrNull(mainLancamentoRowData.ourela),
                            metragemFornecedor: parseFloatOrNull(mainLancamentoRowData.metragemFornecedor),
                            relogio: parseFloatOrNull(mainLancamentoRowData.relogio),
                            idMpTriangulacaoRevLotesPecas: mainLancamentoRowData.LotesPecas.find(item => item.lote == mainLancamentoRowData.lote)?.idMpTriangulacaoRevLotesPecas,
                            pecaCustomizada: mainLancamentoRowData?.nomePeca || ''
                        };
                        if (Object.keys(tonalidade).length > 0) {
                            analisePeca.tonalidade = tonalidade;
                        }

                        const formData = new FormData();
                        formData.append('jsonBody', JSON.stringify(analisePeca));

                        // Agregar imagens parciais acumuladas (do parent) com as imagens do modal atual
                        const imagensAgg = [
                            ...(Array.isArray(tonalidadeImagensAcumuladas) ? tonalidadeImagensAcumuladas : []),
                            ...imagensTonalidade
                        ];

                        imagensAgg.forEach(imagem => {
                            // Garante que o nome do arquivo seja sempre o correto conforme o modal
                            let nomeArquivo = imagem.name;
                            // Corrige nomes para garantir compatibilidade
                            // Se a imagem veio de imagensAcumuladas, pode não existir exatamente em campoFotos
                            // Mantemos o nome original salvo no acumulador, caso contrário tentamos garantir compatibilidade
                            if (modalTonalidadeTipo === 'primeira') {
                                if (imagem.file === campoFotos.imagemInicioMaisMeioDoRolo?.file) nomeArquivo = 'imagemInicioMaisMeioDoRolo.jpg';
                                if (imagem.file === campoFotos.imagemInicioMaisFinalDoRolo?.file) nomeArquivo = 'imagemInicioMaisFinalDoRolo.jpg';
                                if (imagem.file === campoFotos.imagemOurelaEsqCentroDireita?.file) nomeArquivo = 'imagemOurelaEsqCentroDireita.jpg';
                            } else if (modalTonalidadeTipo === 'segunda') {
                                if (imagem.file === campoFotos.imagemPrimeiraMaisSegundaPecaDoLote?.file) nomeArquivo = 'imagemPrimeiraMaisSegundaPecaDoLote.jpg';
                            } else if (modalTonalidadeTipo === 'última') {
                                if (imagem.file === campoFotos.imagemUmaPecaDeCadaLote?.file) nomeArquivo = 'imagemUmaPecaDeCadaLote.jpg';
                            }
                            formData.append('imagensTonalidade', imagem.file, nomeArquivo);
                        });

                        ['larguraFornecedor', 'larguraMeio', 'metragemFornecedor', 'relogio'].forEach(campo => {
                            const foto = campoFotos[mainLancamentoRowData.peca]?.[campo];
                            if (foto?.file) {
                                const nomeArquivo = {
                                    larguraFornecedor: 'imagemLarguraFornecedor',
                                    larguraMeio: 'imagemLarguraMeio',
                                    metragemFornecedor: 'imagemMetragemFornecedor',
                                    relogio: 'imagemRelogio'
                                }[campo];
                                const ext = foto.file.name.substring(foto.file.name.lastIndexOf('.')).toLowerCase();
                                if (ext === '.jpg' || ext === '.jpeg') {
                                    formData.append('files', foto.file, `${nomeArquivo}${ext}`);
                                } else {
                                    toast.error(`Apenas arquivos .jpg ou .jpeg são permitidos para o campo ${nomeArquivo}`);
                                }
                            }
                        });
                        setLoadingModal(true);
                        const novaAnalise = await registrarAnalisePeca(formData, true);
                        if (novaAnalise) {
                            setAnalisesPeca(prev => Array.isArray(prev) ? [...prev, novaAnalise] : [novaAnalise]);
                        }
                        setLoadingModal(false);
                        // Limpar imagens acumuladas no parent após envio bem-sucedido
                        try {
                            if (typeof clearTonalidadeImagens === 'function') clearTonalidadeImagens();
                        } catch (e) {
                            console.error('Erro limpando imagens acumuladas', e);
                        }
                        setMainLancamentoRowData(prev => prev ? {
                            ...prev,
                            lote: '',
                            peca: '',
                            larguraFornecedor: '',
                            larguraInicio: '',
                            larguraMeio: '',
                            larguraFim: '',
                            ourela: '',
                            metragemFornecedor: '',
                            relogio: '',
                            nomePeca: ''
                        } : null);

                        setIndiceSelecionado({ foto1: '', foto2: '', foto3: '', foto4: '', foto5: '' });
                        setStatusSelecionado({ foto1: '', foto2: '', foto3: '', foto4: '', foto5: '' });
                        setCampoFotos({
                            imagemInicioMaisMeioDoRolo: '',
                            imagemInicioMaisFinalDoRolo: '',
                            imagemOurelaEsqCentroDireita: '',
                            imagemPrimeiraMaisSegundaPecaDoLote: '',
                            imagemUmaPecaDeCadaLote: '',
                        });
                        await carregarStatus();
                    }
                } else {
                    // Se há defeitos válidos, envia análise peça + defeitos
                    if (typeof registrarAnalisePecaComDefeitos === 'function' && mainLancamentoRowData) {
                        const parseFloatOrNull = v => {
                            if (v === undefined || v === null || v === '' || v === 'NULL') return null;
                            const n = parseFloat(String(v).replace(',', '.'));
                            return isNaN(n) ? null : n;
                        };
                        const analisePeca = {
                            idMpTriangulacaoRev: mainLancamentoRowData.idMpTriangulacaoRev,
                            pedido: mainLancamentoRowData.pedido,
                            lote: parseFloatOrNull(mainLancamentoRowData.lote),
                            peca: parseFloatOrNull(mainLancamentoRowData.peca),
                            larguraFornecedor: parseFloatOrNull(mainLancamentoRowData.larguraFornecedor),
                            larguraInicio: parseFloatOrNull(mainLancamentoRowData.larguraInicio),
                            larguraMeio: parseFloatOrNull(mainLancamentoRowData.larguraMeio),
                            larguraFim: parseFloatOrNull(mainLancamentoRowData.larguraFim),
                            ourela: parseFloatOrNull(mainLancamentoRowData.ourela),
                            metragemFornecedor: parseFloatOrNull(mainLancamentoRowData.metragemFornecedor),
                            relogio: parseFloatOrNull(mainLancamentoRowData.relogio),
                            idMpTriangulacaoRevLotesPecas: mainLancamentoRowData.LotesPecas.find(item => item.lote == mainLancamentoRowData.lote)?.idMpTriangulacaoRevLotesPecas,
                            pecaCustomizada: mainLancamentoRowData?.nomePeca || ''
                        };
                        if (Object.keys(tonalidade).length > 0) {
                            analisePeca.tonalidade = tonalidade;
                        }
                        const defeitosPayload = defeitosValidos.map((defeito, idx) => ({
                            idMpTriangulacaoRev: mainLancamentoRowData.idMpTriangulacaoRev,
                            idTipoDefeito: defeito.defeito,
                            idLocalizacaoDefeito: defeito.localizacao,
                            idTamanhoDefeito: defeito.tamanho,
                            pontuacao: defeito.pontuacao,
                            consideracaoDefeito: defeito.consideracao || '',
                            imagemDefeito: defeito.file
                                ? `${mainLancamentoRowData.idMpTriangulacaoRev}-${mainLancamentoRowData.pedido}-${mainLancamentoRowData.lote}-${mainLancamentoRowData.peca}-defeito-${idx + 1}.jpg`
                                : null
                        }));
                        const payload = {
                            condenarPeca: defeitosValidos[0]?.condenar ? 1 : 0,
                            analisePeca,
                            defeitos: defeitosPayload
                        };
                        const formData = new FormData();
                        formData.append('jsonBody', JSON.stringify(payload));

                        defeitosValidos.forEach((defeito, idx) => {
                            if (defeito.file) {
                                const nomeArquivo = `${mainLancamentoRowData.idMpTriangulacaoRev}-${mainLancamentoRowData.pedido}-${mainLancamentoRowData.lote}-${mainLancamentoRowData.peca}-defeito-${idx + 1}.jpg`;
                                formData.append('imagensDefeitos', defeito.file, nomeArquivo);
                            }
                        });

                        // Agregar imagens parciais acumuladas (do parent) com as imagens do modal atual
                        const imagensAgg = [
                            ...(Array.isArray(tonalidadeImagensAcumuladas) ? tonalidadeImagensAcumuladas : []),
                            ...imagensTonalidade
                        ];

                        imagensAgg.forEach(imagem => {
                            // Garante que o nome do arquivo seja sempre o correto conforme o modal
                            let nomeArquivo = imagem.name;
                            // Corrige nomes para garantir compatibilidade
                            if (modalTonalidadeTipo === 'primeira') {
                                if (imagem.file === campoFotos.imagemInicioMaisMeioDoRolo?.file) nomeArquivo = 'imagemInicioMaisMeioDoRolo.jpg';
                                if (imagem.file === campoFotos.imagemInicioMaisFinalDoRolo?.file) nomeArquivo = 'imagemInicioMaisFinalDoRolo.jpg';
                                if (imagem.file === campoFotos.imagemOurelaEsqCentroDireita?.file) nomeArquivo = 'imagemOurelaEsqCentroDireita.jpg';
                            } else if (modalTonalidadeTipo === 'segunda') {
                                if (imagem.file === campoFotos.imagemPrimeiraMaisSegundaPecaDoLote?.file) nomeArquivo = 'imagemPrimeiraMaisSegundaPecaDoLote.jpg';
                            } else if (modalTonalidadeTipo === 'última') {
                                if (imagem.file === campoFotos.imagemUmaPecaDeCadaLote?.file) nomeArquivo = 'imagemUmaPecaDeCadaLote.jpg';
                            }
                            formData.append('imagensTonalidade', imagem.file, nomeArquivo);
                        });

                        ['larguraFornecedor', 'larguraMeio', 'metragemFornecedor', 'relogio'].forEach(campo => {
                            const foto = campoFotos[mainLancamentoRowData.peca]?.[campo];
                            if (foto?.file) {
                                const nomeArquivo = {
                                    larguraFornecedor: 'imagemLarguraFornecedor',
                                    larguraMeio: 'imagemLarguraMeio',
                                    metragemFornecedor: 'imagemMetragemFornecedor',
                                    relogio: 'imagemRelogio'
                                }[campo];
                                const ext = foto.file.name.substring(foto.file.name.lastIndexOf('.')).toLowerCase();
                                if (ext === '.jpg' || ext === '.jpeg') {
                                    formData.append('files', foto.file, `${nomeArquivo}${ext}`);
                                } else {
                                    toast.error(`Apenas arquivos .jpg ou .jpeg são permitidos para o campo ${nomeArquivo}`);
                                }
                            }
                        });
                        setLoadingModal(true);
                        const response = await registrarAnalisePecaComDefeitos(formData, true);
                        if (response) {
                            if (response.analisePeca) {
                                setAnalisesPeca(prev => Array.isArray(prev) ? [...prev, response.analisePeca] : [response.analisePeca]);
                            }
                            if (Array.isArray(response.defeitos)) {
                                setDefeitosGrid(response.defeitos);
                            }
                            setLoadingModal(false);
                        }
                        // Limpa defeitos   
                        setMainLancamentoRowData(prev => prev ? {
                            ...prev,
                            lote: '',
                            peca: '',
                            larguraFornecedor: '',
                            larguraInicio: '',
                            larguraMeio: '',
                            larguraFim: '',
                            ourela: '',
                            metragemFornecedor: '',
                            relogio: '',
                            nomePeca: ''
                        } : null);
                        setDefeitos([{ defeito: '', localizacao: '', tamanho: '', consideracao: '', pontuacao: '', condenar: false }]);
                        setIndiceSelecionado({ foto1: '', foto2: '', foto3: '', foto4: '', foto5: '' });
                        setStatusSelecionado({ foto1: '', foto2: '', foto3: '', foto4: '', foto5: '' });
                        setCampoFotos({
                            imagemInicioMaisMeioDoRolo: '',
                            imagemInicioMaisFinalDoRolo: '',
                            imagemOurelaEsqCentroDireita: '',
                            imagemPrimeiraMaisSegundaPecaDoLote: '',
                            imagemUmaPecaDeCadaLote: '',
                        });
                        await carregarStatus();
                    }
                }
                // Só limpar mainLancamentoRowData após o último modal tonalidade
                if (typeof onTonalidadeFinish === 'function') {
                    onTonalidadeFinish();
                }
            }
        } else {
            // Só insere no grid principal se não houver mais modais a abrir (último modal)
            const defeitosValidos = Array.isArray(defeitos) && defeitos.filter(d => d.defeito || d.localizacao || d.tamanho || d.pontuacao);
            if (!defeitosValidos || defeitosValidos.length === 0) {
                if (typeof registrarAnalisePeca === 'function' && mainLancamentoRowData) {
                    const parseFloatOrNull = v => {
                        if (v === undefined || v === null || v === '' || v === 'NULL') return null;
                        const n = parseFloat(String(v).replace(',', '.'));
                        return isNaN(n) ? null : n;
                    };
                    const analisePeca = {
                        idMpTriangulacaoRev: mainLancamentoRowData.idMpTriangulacaoRev,
                        pedido: mainLancamentoRowData.pedido,
                        lote: parseFloatOrNull(mainLancamentoRowData.lote),
                        peca: parseFloatOrNull(mainLancamentoRowData.peca),
                        larguraFornecedor: parseFloatOrNull(mainLancamentoRowData.larguraFornecedor),
                        larguraInicio: parseFloatOrNull(mainLancamentoRowData.larguraInicio),
                        larguraMeio: parseFloatOrNull(mainLancamentoRowData.larguraMeio),
                        larguraFim: parseFloatOrNull(mainLancamentoRowData.larguraFim),
                        ourela: parseFloatOrNull(mainLancamentoRowData.ourela),
                        metragemFornecedor: parseFloatOrNull(mainLancamentoRowData.metragemFornecedor),
                        relogio: parseFloatOrNull(mainLancamentoRowData.relogio),
                        idMpTriangulacaoRevLotesPecas: mainLancamentoRowData.LotesPecas.find(item => item.lote == mainLancamentoRowData.lote)?.idMpTriangulacaoRevLotesPecas,
                        pecaCustomizada: mainLancamentoRowData?.nomePeca || ''
                    };
                    if (Object.keys(tonalidade).length > 0) {
                        analisePeca.tonalidade = tonalidade;
                    }
                    const formData = new FormData();
                    formData.append('jsonBody', JSON.stringify(analisePeca));

                    imagensTonalidade.forEach(imagem => {
                        // Garante que o nome do arquivo seja sempre o correto conforme o modal
                        let nomeArquivo = imagem.name;
                        // Corrige nomes para garantir compatibilidade
                        if (modalTonalidadeTipo === 'primeira') {
                            if (imagem.file === campoFotos.imagemInicioMaisMeioDoRolo?.file) nomeArquivo = 'imagemInicioMaisMeioDoRolo.jpg';
                            if (imagem.file === campoFotos.imagemInicioMaisFinalDoRolo?.file) nomeArquivo = 'imagemInicioMaisFinalDoRolo.jpg';
                            if (imagem.file === campoFotos.imagemOurelaEsqCentroDireita?.file) nomeArquivo = 'imagemOurelaEsqCentroDireita.jpg';
                        } else if (modalTonalidadeTipo === 'segunda') {
                            if (imagem.file === campoFotos.imagemPrimeiraMaisSegundaPecaDoLote?.file) nomeArquivo = 'imagemPrimeiraMaisSegundaPecaDoLote.jpg';
                        } else if (modalTonalidadeTipo === 'última') {
                            if (imagem.file === campoFotos.imagemUmaPecaDeCadaLote?.file) nomeArquivo = 'imagemUmaPecaDeCadaLote.jpg';
                        }
                        formData.append('imagensTonalidade', imagem.file, nomeArquivo);
                    });

                    ['larguraFornecedor', 'larguraMeio', 'metragemFornecedor', 'relogio'].forEach(campo => {
                        const foto = campoFotos[mainLancamentoRowData.peca]?.[campo];
                        if (foto?.file) {
                            const nomeArquivo = {
                                larguraFornecedor: 'imagemLarguraFornecedor',
                                larguraMeio: 'imagemLarguraMeio',
                                metragemFornecedor: 'imagemMetragemFornecedor',
                                relogio: 'imagemRelogio'
                            }[campo];
                            const ext = foto.file.name.substring(foto.file.name.lastIndexOf('.')).toLowerCase();
                            if (ext === '.jpg' || ext === '.jpeg') {
                                formData.append('files', foto.file, `${nomeArquivo}${ext}`);
                            } else {
                                toast.error(`Apenas arquivos .jpg ou .jpeg são permitidos para o campo ${nomeArquivo}`);
                            }
                        }
                    });
                    setLoadingModal(true);
                    const novaAnalise = await registrarAnalisePeca(formData, true);
                    if (novaAnalise) {
                        setAnalisesPeca(prev => Array.isArray(prev) ? [...prev, novaAnalise] : [novaAnalise]);
                    }
                    setLoadingModal(false);
                    setMainLancamentoRowData(prev => prev ? {
                        ...prev,
                        lote: '',
                        peca: '',
                        larguraFornecedor: '',
                        larguraInicio: '',
                        larguraMeio: '',
                        larguraFim: '',
                        ourela: '',
                        metragemFornecedor: '',
                        relogio: '',
                        nomePeca: ''
                    } : null);

                    setIndiceSelecionado({ foto1: '', foto2: '', foto3: '', foto4: '', foto5: '' });
                    setStatusSelecionado({ foto1: '', foto2: '', foto3: '', foto4: '', foto5: '' });
                    setCampoFotos({
                        imagemInicioMaisMeioDoRolo: '',
                        imagemInicioMaisFinalDoRolo: '',
                        imagemOurelaEsqCentroDireita: '',
                        imagemPrimeiraMaisSegundaPecaDoLote: '',
                        imagemUmaPecaDeCadaLote: '',
                    });
                    await carregarStatus();
                }
            } else {
                // Se há defeitos válidos, envia análise peça + defeitos
                if (typeof registrarAnalisePecaComDefeitos === 'function' && mainLancamentoRowData) {
                    const parseFloatOrNull = v => {
                        if (v === undefined || v === null || v === '' || v === 'NULL') return null;
                        const n = parseFloat(String(v).replace(',', '.'));
                        return isNaN(n) ? null : n;
                    };
                    const analisePeca = {
                        idMpTriangulacaoRev: mainLancamentoRowData.idMpTriangulacaoRev,
                        pedido: mainLancamentoRowData.pedido,
                        lote: parseFloatOrNull(mainLancamentoRowData.lote),
                        peca: parseFloatOrNull(mainLancamentoRowData.peca),
                        larguraFornecedor: parseFloatOrNull(mainLancamentoRowData.larguraFornecedor),
                        larguraInicio: parseFloatOrNull(mainLancamentoRowData.larguraInicio),
                        larguraMeio: parseFloatOrNull(mainLancamentoRowData.larguraMeio),
                        larguraFim: parseFloatOrNull(mainLancamentoRowData.larguraFim),
                        ourela: parseFloatOrNull(mainLancamentoRowData.ourela),
                        metragemFornecedor: parseFloatOrNull(mainLancamentoRowData.metragemFornecedor),
                        relogio: parseFloatOrNull(mainLancamentoRowData.relogio),
                        idMpTriangulacaoRevLotesPecas: mainLancamentoRowData.LotesPecas.find(item => item.lote == mainLancamentoRowData.lote)?.idMpTriangulacaoRevLotesPecas,
                        pecaCustomizada: mainLancamentoRowData?.nomePeca || ''
                    };
                    if (Object.keys(tonalidade).length > 0) {
                        analisePeca.tonalidade = tonalidade;
                    }
                    const defeitosPayload = defeitosValidos.map((defeito, idx) => ({
                        idMpTriangulacaoRev: mainLancamentoRowData.idMpTriangulacaoRev,
                        idTipoDefeito: defeito.defeito,
                        idLocalizacaoDefeito: defeito.localizacao,
                        idTamanhoDefeito: defeito.tamanho,
                        pontuacao: defeito.pontuacao,
                        consideracaoDefeito: defeito.consideracao || '',
                        imagemDefeito: defeito.file
                            ? `${mainLancamentoRowData.idMpTriangulacaoRev}-${mainLancamentoRowData.pedido}-${mainLancamentoRowData.lote}-${mainLancamentoRowData.peca}-defeito-${idx + 1}.jpg`
                            : null
                    }));
                    const payload = {
                        condenarPeca: defeitosValidos[0]?.condenar ? 1 : 0,
                        analisePeca,
                        defeitos: defeitosPayload
                    };
                    const formData = new FormData();
                    formData.append('jsonBody', JSON.stringify(payload));

                    defeitosValidos.forEach((defeito, idx) => {
                        if (defeito.file) {
                            const nomeArquivo = `${mainLancamentoRowData.idMpTriangulacaoRev}-${mainLancamentoRowData.pedido}-${mainLancamentoRowData.lote}-${mainLancamentoRowData.peca}-defeito-${idx + 1}.jpg`;
                            formData.append('imagensDefeitos', defeito.file, nomeArquivo);
                        }
                    });
                    imagensTonalidade.forEach(imagem => {
                        // Garante que o nome do arquivo seja sempre o correto conforme o modal
                        let nomeArquivo = imagem.name;
                        // Corrige nomes para garantir compatibilidade
                        if (modalTonalidadeTipo === 'primeira') {
                            if (imagem.file === campoFotos.imagemInicioMaisMeioDoRolo?.file) nomeArquivo = 'imagemInicioMaisMeioDoRolo.jpg';
                            if (imagem.file === campoFotos.imagemInicioMaisFinalDoRolo?.file) nomeArquivo = 'imagemInicioMaisFinalDoRolo.jpg';
                            if (imagem.file === campoFotos.imagemOurelaEsqCentroDireita?.file) nomeArquivo = 'imagemOurelaEsqCentroDireita.jpg';
                        } else if (modalTonalidadeTipo === 'segunda') {
                            if (imagem.file === campoFotos.imagemPrimeiraMaisSegundaPecaDoLote?.file) nomeArquivo = 'imagemPrimeiraMaisSegundaPecaDoLote.jpg';
                        } else if (modalTonalidadeTipo === 'última') {
                            if (imagem.file === campoFotos.imagemUmaPecaDeCadaLote?.file) nomeArquivo = 'imagemUmaPecaDeCadaLote.jpg';
                        }
                        formData.append('imagensTonalidade', imagem.file, nomeArquivo);
                    });

                    ['larguraFornecedor', 'larguraMeio', 'metragemFornecedor', 'relogio'].forEach(campo => {
                        const foto = campoFotos[mainLancamentoRowData.peca]?.[campo];
                        if (foto?.file) {
                            const nomeArquivo = {
                                larguraFornecedor: 'imagemLarguraFornecedor',
                                larguraMeio: 'imagemLarguraMeio',
                                metragemFornecedor: 'imagemMetragemFornecedor',
                                relogio: 'imagemRelogio'
                            }[campo];
                            const ext = foto.file.name.substring(foto.file.name.lastIndexOf('.')).toLowerCase();
                            if (ext === '.jpg' || ext === '.jpeg') {
                                formData.append('files', foto.file, `${nomeArquivo}${ext}`);
                            } else {
                                toast.error(`Apenas arquivos .jpg ou .jpeg são permitidos para o campo ${nomeArquivo}`);
                            }
                        }
                    });
                    const response = await registrarAnalisePecaComDefeitos(formData, true);
                    setLoadingModal(true);
                    if (response) {
                        if (response.analisePeca) {
                            setAnalisesPeca(prev => Array.isArray(prev) ? [...prev, response.analisePeca] : [response.analisePeca]);
                        }
                        if (Array.isArray(response.defeitos)) {
                            setDefeitosGrid(response.defeitos);
                        }
                    }
                    setLoadingModal(false);
                    // Limpa defeitos  
                    setMainLancamentoRowData(prev => prev ? {
                        ...prev,
                        lote: '',
                        peca: '',
                        larguraFornecedor: '',
                        larguraInicio: '',
                        larguraMeio: '',
                        larguraFim: '',
                        ourela: '',
                        metragemFornecedor: '',
                        relogio: '',
                        nomePeca: ''
                    } : null);
                    setDefeitos([{ defeito: '', localizacao: '', tamanho: '', consideracao: '', pontuacao: '', condenar: false }]);
                    setIndiceSelecionado({ foto1: '', foto2: '', foto3: '', foto4: '', foto5: '' });
                    setStatusSelecionado({ foto1: '', foto2: '', foto3: '', foto4: '', foto5: '' });
                    setCampoFotos({
                        imagemInicioMaisMeioDoRolo: '',
                        imagemInicioMaisFinalDoRolo: '',
                        imagemOurelaEsqCentroDireita: '',
                        imagemPrimeiraMaisSegundaPecaDoLote: '',
                        imagemUmaPecaDeCadaLote: '',
                    });
                }
                await carregarStatus();
            }
            if (typeof onTonalidadeFinish === 'function') {
                onTonalidadeFinish();
            }
        }
    };

    const handleFileChange = (fieldName, file) => {
        if (file) {
            const ext = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
            if (ext === '.jpg' || ext === '.jpeg') {
                setCampoFotos(prev => ({ ...prev, [fieldName]: { file } }));
                toast.success('Arquivo salvo com sucesso!');
            } else {
                toast.error('Apenas arquivos .jpg ou .jpeg são permitidos.');
            }
        }
    };

    const getStatusOptions = (indice) => {
        let recomendado = null;
        const tipoTecidoAtual = mainLancamentoRowData?.tipoTecido;
        
        if (tipoTecidoAtual === 'tinto') {
            recomendado = aprovadorTecidoTinto.includes(indice) ? 'aprovado' : 'reprovado';
        } else if (tipoTecidoAtual === 'estampado') {
            recomendado = aprovadorTecidoEstampado.includes(indice) ? 'aprovado' : 'reprovado';
        }
        
        if (recomendado === 'aprovado') {
            return [
                <option key="aprovado" value="aprovado">Aprovado (Recomendado)</option>,
                <option key="reprovado" value="reprovado">Reprovado</option>
            ];
        } else {
            return [
                <option key="reprovado" value="reprovado">Reprovado (Recomendado)</option>,
                <option key="aprovado" value="aprovado">Aprovado</option>
            ];
        }
    };

    const renderFotoSection = (fotoNumber, fieldName, label) => (
            <div className={styles.fotoModalFotoCol}>
                <div className={styles.fotoModalLabel} style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: 8, whiteSpace: 'nowrap' }}>
                    <span style={{ fontWeight: 600, fontSize: '1rem' }}>{label}</span>
                <input
                    id={`fileInput_${fieldName}`}
                    type="file"
                    accept=".jpg,.jpeg,image/jpg,image/jpeg"
                    style={{ display: 'none' }}
                    onChange={e => handleFileChange(fieldName, e.target.files[0])}
                />
                <button
                    type="button"
                    className={styles.cameraButton}
                    onClick={() => document.getElementById(`fileInput_${fieldName}`).click()}
                    style={{
                        background: 'none',
                        border: 'none',
                        padding: 0,
                        marginLeft: 4,
                        cursor: 'pointer',
                        filter: campoFotos[fieldName]?.file ? 'invert(41%) sepia(98%) saturate(749%) hue-rotate(85deg) brightness(95%) contrast(92%)' : 'none'
                    }}
                >
                    <img src="/img/camera_icon.png" alt="Anexar foto" style={{ width: 20, height: 20 }} />
                </button>
                <span style={{
                    marginLeft: 12,
                    alignSelf: 'center',
                    fontWeight: 500,
                    color: '#202D3B',
                    fontSize: '0.95rem',
                    marginTop: 4,
                    whiteSpace: 'nowrap',
                    filter: campoFotos[fieldName]?.file ? 'invert(41%) sepia(98%) saturate(749%) hue-rotate(85deg) brightness(95%) contrast(92%)' : 'none'
                }}>
                    {campoFotos[fieldName]?.file ? 'Foto Incluída!' : 'Inclua a Foto *'}
                </span>
            </div>
            <div className={styles.fotoModalInputRow}>
                <label className={styles.fotoModalLabel}>Indice: *</label>
                <select
                    className={styles.fotoModalSelect}
                    value={indiceSelecionado[fotoNumber] || ''}
                    onChange={e => setIndiceSelecionado(prev => ({ ...prev, [fotoNumber]: e.target.value }))}
                >
                    <option value="">Selecione</option>
                    {Array.isArray(indicesModalTonalidade) && indicesModalTonalidade.length > 0 ? (
                        indicesModalTonalidade.map((item, idx) => {
                            const indiceValue = item?.indice || item;
                            return (
                                <option key={idx} value={indiceValue}>
                                    {indiceValue}
                                </option>
                            );
                        })
                    ) : (
                        <option value="" disabled>Carregando índices...</option>
                    )}
                </select>
            </div>
            {indiceSelecionado[fotoNumber] && (
                <div className={styles.fotoModalInputRow}>
                    <label className={styles.fotoModalLabel}>Status:</label>
                    <select
                        className={styles.fotoModalSelect}
                        value={statusSelecionado[fotoNumber]}
                        onChange={e => setStatusSelecionado(prev => ({ ...prev, [fotoNumber]: e.target.value }))}
                        disabled={!indiceSelecionado[fotoNumber]}
                    >
                        <option value="" disabled>Selecione</option>
                        {getStatusOptions(indiceSelecionado[fotoNumber])}
                    </select>
                </div>
            )}
        </div>
    );

    const renderPrimeiraModal = () => (
        <div className={styles.modalPrimeira}>
            <div className={styles.fotoModalTitleRow}>
                <div className={styles.fotoModalTitleBox}>
                    <span className={styles.fotoModalTitle}>TONALIDADE NO MESMO ROLO</span>
                </div>
            </div>
            <div className={styles.fotoModalFotosRow}>
                {renderFotoSection('foto1', 'imagemInicioMaisMeioDoRolo', 'Foto 1')}
                {renderFotoSection('foto2', 'imagemInicioMaisFinalDoRolo', 'Foto 2')}
                {renderFotoSection('foto3', 'imagemOurelaEsqCentroDireita', 'Foto 3')}
            </div>
            <button
                className={styles.btnSalvar}
                onClick={() => {
                    if (setLoadingModal) setLoadingModal(true);
                    finalizarTonalidadeModal();
                }}
                style={{ minWidth: 120 }}
                disabled={
                    !(
                        campoFotos.imagemInicioMaisMeioDoRolo?.file &&
                        indiceSelecionado.foto1 &&
                        campoFotos.imagemInicioMaisFinalDoRolo?.file &&
                        indiceSelecionado.foto2 &&
                        campoFotos.imagemOurelaEsqCentroDireita?.file &&
                        indiceSelecionado.foto3
                    )
                }
            >Finalizar</button>
        </div>
    );

    const renderSegundaModal = () => (
        <div className={styles.modalPrimeira}>
            <div className={styles.fotoModalTitleRow}>
                <div className={styles.fotoModalTitleBox}>
                    <span className={styles.fotoModalTitle}>TONALIDADE NO MESMO LOTE</span>
                </div>
            </div>
            {renderFotoSection('foto4', 'imagemPrimeiraMaisSegundaPecaDoLote', 'Foto 4')}
            <button
                className={styles.btnSalvar}
                onClick={() => {
                    if (setLoadingModal) setLoadingModal(true);
                    finalizarTonalidadeModal();
                }}
                style={{ minWidth: 120 }}
                disabled={
                    !(
                        campoFotos.imagemPrimeiraMaisSegundaPecaDoLote?.file &&
                        indiceSelecionado.foto4
                    )
                }
            >Finalizar</button>
        </div>
    );

    const renderUltimaModal = () => (
        <div className={styles.modalPrimeira}>
            <div className={styles.fotoModalTitleRow}>
                <div className={styles.fotoModalTitleBox}>
                    <span className={styles.fotoModalTitle}>TONALIDADE ENTRE LOTES</span>
                </div>
            </div>
            {renderFotoSection('foto5', 'imagemUmaPecaDeCadaLote', 'Foto 5')}
            <button
                className={styles.btnSalvar}
                onClick={() => {
                    if (setLoadingModal) setLoadingModal(true);
                    finalizarTonalidadeModal();
                }}
                style={{ minWidth: 120 }}
                disabled={
                    !(
                        campoFotos.imagemUmaPecaDeCadaLote?.file &&
                        indiceSelecionado.foto5
                    )
                }
            >Finalizar</button>
        </div>
    );

    // Se os índices ainda estão carregando, mostrar indicador
    if (!Array.isArray(indicesModalTonalidade) || indicesModalTonalidade.length === 0) {
        return (
            <div className={styles.modalOverlay}>
                <div className={styles.modalPrimeira}>
                    <div className={styles.fotoModalTitleRow}>
                        <div className={styles.fotoModalTitleBox}>
                            <span className={styles.fotoModalTitle}>Carregando índices de tonalidade...</span>
                        </div>
                    </div>
                    <div style={{ padding: 20, textAlign: 'center' }}>
                        <div className="spinner-border" role="status" style={{ color: '#202D3B' }}>
                            <span className="visually-hidden">Carregando...</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={styles.modalOverlay}>
            {modalTonalidadeTipo === "primeira" && renderPrimeiraModal()}
            {modalTonalidadeTipo === "segunda" && renderSegundaModal()}
            {modalTonalidadeTipo === "última" && renderUltimaModal()}
        </div>
    );
};

export default TonalidadeModal;